<div class="map-container"></div><ng-content></ng-content>